import { ImgHTMLAttributes } from 'react';
import { versionedCharacterImage } from '../../util/poseAsset';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  imgref?: React.RefObject<HTMLImageElement>;
}

/**
 * A CDN pathed version of the <img /> element.
 */
export function CDNImage(props: Props) {
  return (
    <img
      {...props}
      crossOrigin={process.env.NODE_ENV === 'development' ? undefined : 'anonymous'}
      ref={props.imgref}
      src={props.src?.startsWith('/hy/') ? props.src : versionedCharacterImage(`${process.env.REACT_APP_CDN_PATH ?? ''}${props.src}`)}
    />
  );
}
